import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }

    // Delay the refresh to wait for the drawer content to load
    requestAnimationFrame(() => {
      setTimeout(() => {
        this.refreshCartDrawer();
      }, 100); // Adjust timing as needed
    });
  };

  open() {
    this.showDialog();
    this.refreshCartDrawer();

    // Close cart drawer when Shopify installments CTA is clicked
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document
        .querySelector('shopify-payment-terms')
        ?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  refreshCartDrawer() {
    const container = document.querySelector('.recommended-products');
    if (!container) return;

    // Destroy previous instance (if any)
    if (container.swiper) {
      container.swiper.destroy(true, true);
    }

    // Initialize Swiper
    new Swiper('.recommended-products', {
      slidesPerView: 'auto',
      spaceBetween: 15,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
